import { useEffect, useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast } from "react-toastify";
import BarLoader from "../../components/Loader/BarLoader";
import { updateVendor } from "../../services/VendorServices";

const validationSchema = Yup.object({
  name: Yup.string().required("Vendor Name is required"),
});

function EditVendor({ showModal, setShowModal, vendorData, onVendorUpdated }) {
  const [updating, setUpdating] = useState(false);

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: "",
      contactPersonName: "",
      email: "",
      mobileNumber: "",
      address: "",
    },
  });

  useEffect(() => {
    if (vendorData) {
      reset({
        name: vendorData.name || "",
        contactPersonName: vendorData.contact_person_name || "",
        email: vendorData.email || "",
        mobileNumber: vendorData.mobile_number || "",
        address: vendorData.address || "",
      });
    }
  }, [vendorData, reset]);

  const handleClose = () => {
    reset();
    setShowModal(false);
  };

  const onSubmit = async (formData) => {
    try {
      const payload = {
        name: formData.name,
        contact_person_name: formData.contactPersonName,
        email: formData.email,
        mobile_number: formData.mobileNumber,
        address: formData.address,
      };

      setUpdating(true);
      const res = await updateVendor(vendorData.id, payload);
      toast.success("Vendor updated successfully");
      if (onVendorUpdated) onVendorUpdated(res.data);
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update vendor");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Vendor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Vendor Name</Form.Label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <Form.Control {...field} isInvalid={!!errors.name} />
                  )}
                />
                {errors.name && (
                  <div className="text-danger small">{errors.name.message}</div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Contact Person</Form.Label>
                <Controller
                  name="contactPersonName"
                  control={control}
                  render={({ field }) => (
                    <Form.Control {...field} />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <Form.Control {...field} />
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Mobile Number</Form.Label>
                <Controller
                  name="mobileNumber"
                  control={control}
                  render={({ field }) => (
                    <Form.Control {...field} />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <Form.Control as="textarea" rows={2} {...field} />
              )}
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="outline-danger" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={updating}>
              {updating ? <BarLoader /> : "Update"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditVendor;
